/* eslint-disable */ 
$(document).ready(function() {
    $('#close-menu').click(function() {
      $('.second-level-menu-mobile').css({"left":"-100%"});
    });
  
    // Toggle the checkbox when the hamburger menu is clicked
    $('.menu-toggler-mobile').click(function() {
        $('#toggle-mobile').prop('checked', !$('#toggle-mobile').prop('checked'));
        // Slide the mobile menu down or up
        $('#mobileMenu').slideToggle('2000');
    });

    // When a submenu item is clicked, show the submenu and hide the main menu
    $('.full-menu-toggler').click(function(event) {
        
        var submenu = $(this).next('.second-level-menu-mobile');
        var lastAction = submenu.data('lastAction');
        
        submenu.animate({"left":"0"}, 300);
        submenu.data('lastAction', 'slideDown');
        
        $('.full-menu-back').show(); // Show the back arrow
    });

    //When the back arrow is clicked, show the main menu and hide the submenu
    $('.full-menu-back').click(function(event) {
        
        $(this).closest('.second-level-menu-mobile').animate({"left":"-100%"}, 300);
        
    });
});
/* eslint-enable */ 